var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173.43 195.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 2693.4 434.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-320-55.002c0 27.615-22.387 50.002-50.002 50.002-27.613 0-49.998-22.387-49.998-50.002 0-27.613 22.385-49.998 49.998-49.998 27.615 0 50.002 22.385 50.002 49.998z",
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m381.45-86.584v305.04c0 36.27 15.096 54.42 45.222 54.42h7.662v20.67h-162.47v-20.67h10.722c30.654 0 45.996-18.15 45.996-54.42v-200.06c0-36.774-13.032-55.17-39.108-55.17h-16.092v-20.694h6.138c31.686 0 60.282-9.702 85.83-29.112h16.098zm107.31 7.638h138.73c17.904 0 28.626-2.016 32.214-6.12h19.932l-11.508 52.128h-169.37l-16.092 75.096c23.988-9.702 45.468-14.568 64.374-14.568 36.798 0 67.83 12.294 93.12 36.81 25.29 24.504 37.92 55.158 37.92 91.968 0 42.912-16.338 77.388-49.02 103.48-30.69 24-67.746 36.024-111.15 36.024-25.548 0-50.58-3.846-75.096-11.508l7.638-19.146c20.424 5.604 38.58 8.412 54.42 8.412 31.686 0 59.412-10.452 83.166-31.404 23.766-20.952 35.616-47.04 35.616-78.186 0-27.072-8.79-49.314-26.412-66.678-17.646-17.37-39.726-26.064-66.306-26.064-25.032 0-48.27 8.694-69.75 26.064l-13.008-2.298 40.59-174.01z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana15);
export default __webpack_public_path__ + "static/media/mana15.bbc6099db4b26aea8968eb8b0bc8c290.svg";
export { ForwardRef as ReactComponent };